import { IAxisesAndLegendsResult } from './axisesAndLegends';
import { isNil, isArray } from 'lodash';
import { colorService } from '@/container';

const defaultColors: string[] = ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'];

function areCustomColorsDefined(axisesAndLegendsResult: IAxisesAndLegendsResult): boolean {
	if (Array.isArray(axisesAndLegendsResult.input.options.config)) {
		return !isNil(axisesAndLegendsResult) && !isNil(axisesAndLegendsResult.input)
			&& !isNil(axisesAndLegendsResult.input.options) && !isNil(axisesAndLegendsResult.input.options.config)
			&& axisesAndLegendsResult.input.options.config.length > 0 && !isNil(axisesAndLegendsResult.input.options.config[0].colors)
			&& isArray(axisesAndLegendsResult.input.options.config[0].colors)
			&& axisesAndLegendsResult.input.options.config[0].colors.length > 0;
	}
	return !isNil(axisesAndLegendsResult) && !isNil(axisesAndLegendsResult.input)
		&& !isNil(axisesAndLegendsResult.input.options) && !isNil(axisesAndLegendsResult.input.options.config)
		&& !isNil(axisesAndLegendsResult.input.options.config.colors) && isArray(axisesAndLegendsResult.input.options.config.colors)
		&& axisesAndLegendsResult.input.options.config.colors.length > 0;
}

function getDefaultColorIndex(i) {
	const defaultColorsCount = defaultColors.length;
	const multiplier = Math.floor(i / defaultColorsCount);
	const subtraction = multiplier * defaultColorsCount;
	return i - subtraction;
}

export function tryApplyCustomColors(axisesAndLegendsResult: IAxisesAndLegendsResult): IAxisesAndLegendsResult {
	// implement reasoning about colors
	const colors: any[] = [];
	const seriesArray = axisesAndLegendsResult.input.options.chartType === 'pie' && (isArray(axisesAndLegendsResult.output.chartResult.series) && axisesAndLegendsResult.output.chartResult.series.length > 0)
		? (axisesAndLegendsResult.output.chartResult.series[0] as any).data
		: axisesAndLegendsResult.output.chartResult.series;

	seriesArray.forEach((series, index) => {
		let colorConfig: any = null;
		if (areCustomColorsDefined(axisesAndLegendsResult)) {
			if (axisesAndLegendsResult.input.options.chartType === 'pie') {
				colorConfig = _.isArray(axisesAndLegendsResult.input.options.config)
					? axisesAndLegendsResult.input.options.config[0].colors[index]
					: axisesAndLegendsResult.input.options.config.colors[index];
			} else {
				colorConfig = _.isArray(axisesAndLegendsResult.input.options.config)
					? axisesAndLegendsResult.input.options.config[0].colors.find((color: any) =>
						color.value === series.nameCode)
					: axisesAndLegendsResult.input.options.config.colors.find((color: any) =>
						color.value === series.nameCode);
			}
		}

		if (!isNil(colorConfig))
			colors.push(colorConfig.fillColor);
		else
			colors.push(colorService.getNewColor());
	});

	axisesAndLegendsResult.output.chartResult.options.colors = colors;
	return axisesAndLegendsResult;
}
